var map = {
	"./avatars/avatar": 33,
	"./avatars/avatar-3": 34,
	"./avatars/avatar-3.png": 34,
	"./avatars/avatar.jpg": 33,
	"./errors-images/404-error": 35,
	"./errors-images/404-error.png": 35,
	"./errors-images/505-error": 36,
	"./errors-images/505-error.png": 36,
	"./lexiqamus-logo": 37,
	"./lexiqamus-logo.png": 37,
	"./lexiqamus-sidebar-logo": 38,
	"./lexiqamus-sidebar-logo.png": 38,
	"./lexiqamus/innovation_announcements/hareket1": 17,
	"./lexiqamus/innovation_announcements/hareket1.jpg": 17,
	"./lexiqamus/innovation_announcements/hareket2": 18,
	"./lexiqamus/innovation_announcements/hareket2.jpg": 18,
	"./lexiqamus/innovation_announcements/hareket3": 19,
	"./lexiqamus/innovation_announcements/hareket3.jpg": 19,
	"./lexiqamus/innovation_announcements/hareket4": 20,
	"./lexiqamus/innovation_announcements/hareket4.jpg": 20,
	"./lexiqamus/innovation_announcements/original-document": 21,
	"./lexiqamus/innovation_announcements/original-document.png": 21,
	"./lexiqamus/innovation_announcements/smart-results": 22,
	"./lexiqamus/innovation_announcements/smart-results.png": 22,
	"./lexiqamus/landing/hareket1": 39,
	"./lexiqamus/landing/hareket1.jpg": 39,
	"./lexiqamus/landing/hareket2": 40,
	"./lexiqamus/landing/hareket2.jpg": 40,
	"./lexiqamus/landing/hareket3": 41,
	"./lexiqamus/landing/hareket3.jpg": 41,
	"./lexiqamus/landing/hareket4": 42,
	"./lexiqamus/landing/hareket4.jpg": 42,
	"./lexiqamus/landing/original-document": 43,
	"./lexiqamus/landing/original-document.png": 43,
	"./lexiqamus/landing/smart-results": 44,
	"./lexiqamus/landing/smart-results.png": 44,
	"./logo-icon": 45,
	"./logo-icon.png": 45,
	"./lq-logo": 46,
	"./lq-logo.png": 46
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 127;